import { PosVendaSlaEstado } from '../../types/posVenda';
import { enumIgnorandoCaixa } from './posVendaEnumDisplay';

export const SLA_ESTADOS_TODOS: PosVendaSlaEstado[] = [
  'NoPrazo',
  'EmRisco',
  'Vencido',
  'ConcluidoNoPrazo',
  'ConcluidoForaDoPrazo',
];

/** Estados 0–2 (pendentes): chips No prazo / Em risco / Vencido. */
export function slaEstadoEstaPendente(estado: PosVendaSlaEstado | string): boolean {
  const canon = slaEstadoCanonicoFromApi(estado);
  return canon === 'NoPrazo' || canon === 'EmRisco' || canon === 'Vencido';
}

const NUMERIC_SLA: Record<number, PosVendaSlaEstado> = {
  0: 'NoPrazo',
  1: 'EmRisco',
  2: 'Vencido',
  3: 'ConcluidoNoPrazo',
  4: 'ConcluidoForaDoPrazo',
};

/** Normaliza valor da API (número 0–4 ou string camelCase). */
export function slaEstadoCanonicoFromApi(value: string | number | null | undefined): PosVendaSlaEstado {
  if (typeof value === 'number' && Number.isFinite(value) && NUMERIC_SLA[value]) {
    return NUMERIC_SLA[value];
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d+$/.test(trimmed)) {
      const n = Number(trimmed);
      if (NUMERIC_SLA[n]) return NUMERIC_SLA[n];
    }
    return enumIgnorandoCaixa(trimmed, SLA_ESTADOS_TODOS) ?? 'NoPrazo';
  }
  return 'NoPrazo';
}
